module.exports = __webpack_public_path__ + "img/SL-M-260-320.48e2009f.svg";